/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCyclesGetResponseFromDiscriminatorValue, type CyclesGetResponse } from '../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}/upcomingcycles
 */
export interface UpcomingcyclesRequestBuilder extends BaseRequestBuilder<UpcomingcyclesRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CyclesGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CyclesGetResponse[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const UpcomingcyclesRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}/upcomingcycles";
/**
 * Metadata for all the requests in the request builder.
 */
export const UpcomingcyclesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: UpcomingcyclesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCyclesGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
